module.exports = __webpack_public_path__ + "img/e4.dedbc6de.png";